
export const QuizSessionReducerPluginFactorySymbol = Symbol.for('Factory<QuizSessionReducerPlugin>')

export const QuizSessionReducerPluginSymbol = Symbol.for('QuizSessionReducerPlugin')
export interface QuizSessionReducerPlugin<T = unknown, TCommand = unknown> {
  reduce(state: T, command: TCommand): T
}
